<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar
          :is-condensed="isMenuCondensed"
          :type="leftSidebarType"
          :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <div class="ms-5 mt-5 w-100">
        </div>
        <h2 class="h-text">{{$t('message.Applications')}}</h2>
        <b-row>
          <b-col md="6" >
            <div class="w-75" style="margin-left: 70px">
              <label>{{$t('message.Position_level')}}</label>
              <b-form-select
                  v-model="form.position_level_id"
                  :options="position_level"
                  text-field="name_uz"
                  value-field="id"
                  class="form-select d-flex"
                  aria-label="Default select example"></b-form-select>
            </div>
          </b-col>
          <b-col md="6">
            <div class="w-75" style="margin-left: 70px">
              <label>{{$t('message.Positions')}}</label>
              <b-form-select
                  v-model="form.position_id"
                  :options="positions"
                  text-field="name_uz"
                  value-field="id"
                  class="form-select d-flex"
                  aria-label="Default select example"></b-form-select>
            </div>
          </b-col>
        </b-row>
        <div class="mt-4 d-flex justify-content-end buttons">
          <div>
            <b-button variant="warning" size="lg" @click="fetchApplications" style="width: 150px; border-radius: 20px">
              <div style="color: #185d89">
                {{$t('message.Search')}}
              </div>
            </b-button>
            <b-button size="lg" class="me-2" @click="resetFilter" style="width: 150px; background-color: #185d89; border-radius: 20px" >
              {{$t('message.Clear')}}
            </b-button>
          </div>
        </div>
        <b-card class="mt-3" style=" width: 90%; margin: 0 auto">
        <b-table
            responsive
            striped
            hover
            :items="applications"
            :fields="fields">
          <template #cell(objective)="{item}">
            <img :src="$backendHost+item.objective" width="100" alt="">
          </template>
          <template #cell(goverment_reward)="{item}">
            <img :src="$backendHost+item.goverment_reward" width="100" alt="">
          </template>
          <template #cell(network_reward)="{item}">
            <img :src="$backendHost+item.network_reward" width="100" alt="">
          </template>
          <template #cell(teacher_competition)="{item}">
            <img :src="$backendHost+item.teacher_competition" width="100" alt="">
          </template>
          <template #cell(other_reward)="{item}">
            <img :src="$backendHost+item.other_reward" width="100" alt="">
          </template>
          <template #cell(language_level)="{item}">
            <span v-for="(item, index) in JSON.parse(item.language_level)" :key="index" class="w-100">
              {{item.name}}
            </span>
          </template>
          <template #cell(created_at)="{item}">
            {{item.created_at | formatDate}}
          </template>
          <template #cell(action)="data">
            <b-button
                style="background-color: #185d89"
                size="md" @click="showAppModal(data.item)">
              <i class="bx bx-show"></i>
            </b-button>
          </template>
        </b-table>
          <div class="w-100 d-flex justify-content-end mt-4">
            <b-pagination
                v-model="pagination.page"
                :total-rows="total"
                :per-page="pagination.pageSize"
                aria-controls="my-table"
                @page-click="fetchApplications"
            ></b-pagination>
          </div>
        </b-card>
        <b-modal v-model="applicationModal" hide-footer size="lg">
          <b-row v-if="activeApplication">
            <b-col md="6">
              <div class="w-100 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.FullName')}}</h5>
                <p>{{activeApplication.fio}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Category')}}</h5>
                <p>{{activeApplication.category ? activeApplication.category.name : ''}}</p>
              </div>
              <div v-if="!!activeApplication.education" class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Education')}}</h5>
                <p>{{activeApplication.education.name}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Experience')}}</h5>
                <p>{{activeApplication.experience ? activeApplication.experience.name : ''}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Work_experience')}}</h5>
                <p v-for="(exp, expIndex) in activeApplication.working_experiences" :key="expIndex">
                  {{exp.experience.name}} - {{exp.year}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Mobile_number')}}</h5>
                <p>{{activeApplication.mobile}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Address')}}</h5>
                <p>{{activeApplication.address}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.LastWorkPlace')}}</h5>
                <p>{{activeApplication.last_work_place}}</p>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.ReasonDischarging')}}</h5>
                <p>{{activeApplication.reason_discharging}}</p>
              </div>
            </b-col>
            <b-col md="6">
              <div class="w-100 border-bottom">
                <h5>{{$t('message.LanguageLevel')}}</h5>
                <div v-if="activeApplication.language_levels">
                  <div class="w-100 my-1" v-for="(lang, langIndex) in activeApplication.language_levels" :key="langIndex">
                    {{lang.language.name}} - {{lang.level.name}}
                  </div>
                </div>
              </div>
              <div v-if="activeApplication.objective !== 'null'" class="w-100 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.Objective')}}</h5>
                <a :href="$backendHost+activeApplication.objective" target="_blank" class="btn btn-outline-warning">
                  <i class="bx bx-download"></i>
                </a>
              </div>
              <div class="w-100 border-bottom" v-if="activeApplication.government_reward !== 'null'">
                <h5 class="font-weight-semibold">{{$t('message.Government_reward')}}</h5>
                <a :href="$backendHost+activeApplication.government_reward" target="_blank" class="btn btn-outline-warning">
                  <i class="bx bx-download"></i>
                </a>
              </div>
              <div class="w-100 border-bottom" v-if="activeApplication.other_reward !== 'null'">
                <h5 class="font-weight-semibold">{{$t('message.Other_reward')}}</h5>
                <a :href="$backendHost+activeApplication.other_reward" target="_blank" class="btn btn-outline-warning">
                  <i class="bx bx-download"></i>
                </a>
              </div>
              <div class="w-100 border-bottom" v-if="activeApplication.workable_document !== 'null'">
                <h5 class="font-weight-semibold">{{$t('message.Entitling')}}</h5>
                <a :href="$backendHost+activeApplication.workable_document" target="_blank" class="btn btn-outline-warning">
                  <i class="bx bx-download"></i>
                </a>
              </div>
              <div class="w-100 mt-2 border-bottom">
                <h5 class="font-weight-semibold">{{$t('message.PINFL')}}</h5>
                <p>{{activeApplication.pinfl}}</p>
              </div>
            </b-col>
          </b-row>
        </b-modal>
      </div>
    </div>
  </div>

</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getSchoolVacancyApplications} from "../../../../../../api/school-vacany-applications";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";
import moment from "moment";
import {getPositionLevels, getPositions} from "../../../../../../api/directories";


export default {
  name: "Applications",
  components: {
    HorizontalTopbarInside, SideBar
  },
  filters:{
    formatDate(val) {
      return moment(val).format('DD-YY-YYYY')
    }
  },
  data() {
    return {
      isMenuCondensed: false,
      selected: null,
      applications:[],
      position_level:[],
      positions:[],
      applicationModal: false,
      pagination:{
        page: 1,
        pageSize: 20,
      },
      total: 1,
      form:{
        position_level_id : null,
        position_id : null,
      },
      fields: [
        {
          key:'id',
          label: this.$t('message.Id'),
        },
        {
          key:'fio',
          label: this.$t('message.First_name')
        },
        {
          key:'mobile',
          label: this.$t('message.Mobile_number')
        },
        {
          key: "vacancy.position_level.name",
          label: this.$t('message.Position_level')
        },
        {
          key:"vacancy.position.name",
          label: this.$t('message.Positions')
        },
        {
          key: 'created_at',
          label: this.$t('message.Submission_date')
        },
        {
          key: 'action',
          label: this.$t('message.Action'),
        }
      ],
      activeApplication: null,
    };
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchApplications()
    this.fetchPositionLevel()
    this.fetchPositions()
  },
  methods: {
    fetchApplications(){
      // eslint-disable-next-line no-console

      getSchoolVacancyApplications({...this.pagination, ...this.form}).then(response => {
        this.applications = response.data.data.data
        this.total = response.data.data.total
      })
    },
    fetchPositionLevel(){
      getPositionLevels().then(response => {
        this.position_level = response.data.data
      })
    },
    fetchPositions(){
      getPositions().then(response => {
        this.positions = response.data.data
      })
    },
    resetFilter() {
      this.form.rayon_id = null;
      this.form.position_level_id = null;
      this.form.position_id = null
      this.form.region_id = null;
      this.form.school_id = null;
      this.fetchApplications()
    },
    showAppModal(item) {
      this.applicationModal= true;
      this.activeApplication = item;
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    handlePush(){
      this.$router.push({name: 'addjob'})
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #185d89;
}
.has-search .form-control {
  padding-left: 28px;
}
.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}
.buttons{
  margin-right: 50px;
}
</style>



